export default __webpack_public_path__ + "static/media/CouchBuddies.48878b05.png";